import { formatMessage } from "../../../../utils/helpers/LanguageHelper";
import useDropDownSheet, { DropDownSheetProps } from "./DropDownSheetHook";
import { SearchableCombobox, SearchableComboboxOption } from "../../../inputs/SearchableCombobox";
import React from "react";

export const DropDownSheet = (props: DropDownSheetProps) => {
  const {
    isEdit,
    sheetsItems,
    selectSheetComboBox,
    isFileExcelExisting,
    isComponentInstance,
    isLocked,
    isOldValueForSheetToHide,
    isLoadingDataExcel,
  } = useDropDownSheet(props);

  function getSelectedKey() {
    if (props.isSheetChartAndAreaToHide && (props.isImageUnchecked || props.objectSourceImage?.includes("IMAGE"))) {
      return null;
    }
    return props.sheet?.code?.toString() ?? null;
  }

  const mappedOptions: SearchableComboboxOption[] = sheetsItems.map((item) => ({
    key: String(item.key),
    text: item.text ?? "",
  }));

  return (
    <>
      <SearchableCombobox
        id="sheet_dropdown"
        loading={isLoadingDataExcel}
        placeholder={isLoadingDataExcel ? formatMessage("cof.base.loadingdata") : formatMessage("cof.base.select")}
        label={formatMessage("cof.createnewobject.sheet")}
        options={isLoadingDataExcel ? [] : mappedOptions}
        onOptionSelect={selectSheetComboBox}
        selectedKey={getSelectedKey() ?? undefined}
        disabled={props.form == null || !isFileExcelExisting || isComponentInstance || isLocked}
        required
      />
      {props.objectSource === "EXCEL" && isEdit && !isLoadingDataExcel && (
        <span
          style={{ color: "red" }}
          hidden={
            !props.sheet?.code ||
            sheetsItems.length === 0 ||
            (sheetsItems.find((value) => value?.key === props?.sheet?.code) && isOldValueForSheetToHide) ||
            props.isSheetChartAndAreaToHide ||
            props.sheet?.code?.toString() !== props.sheet?.desc?.toString()
          }
        >
          {formatMessage("cof.base.oldvalue")} {props.sheet?.desc?.toString()}
        </span>
      )}
    </>
  );
};
